import React from 'react';
import styles from './status-cell-render.module.scss';

export const statusCellRender = ( { value, displayValue }, colorizeRules, colorizeFunc) => <div
 className={`${styles.status} otk-tag otk-status otk-status-${colorizeFunc?.(value) ?? colorizeRules?.[value] ?? 'default'}`}
>{value?.text ?? displayValue}</div>;
